import React, { useState } from 'react';
import { FormControlLabelAndPopover } from '../FormControlLabel';
import { ValidationErrorsMessages } from '../FormValidation';

export const SelectBoxControl = ({ field, handleChange, handleBlur, formDataEntry, errors } : ControlParameters) : JSX.Element => {

  const [selectedValue, setSelectedValue] = useState(null);

  const options = field.settings.Options.split('\n').map(option => {
    const [value, label] = option.split(';');
    return { value, label };
  });

  if(formDataEntry && formDataEntry.value != selectedValue) {
    setSelectedValue(formDataEntry.value);
  }

  const onSelect = (value) => {
    setSelectedValue(value);
    handleChange({ target: { name: field["@column"], value } });
  };

  return (
    <div className={`form-group ${field.properties?.fieldcssclass ?? ''}`} >
      <FormControlLabelAndPopover field={field} loading={false} />
      <div className="div-block-selector">
        {options.map(({ value, label }) => (
          <div
            id={`${field["@column"]}-${value}`}
            key={`${field["@guid"]}-${value}`}
            onBlur={handleBlur}
            // key={value}
            className={`div-block ${selectedValue === value ? 'selected' : ''}`}
            onClick={() => onSelect(value)}
          >
            {label}
          </div>
        ))}
      </div>
      <ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />
    </div>
  );
};